import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.submitHandler = this.submitHandler.bind(this)
    document.addEventListener('submit', this.submitHandler, true)
    console.debug('[workflow] connected')
  }

  disconnect() {
    document.removeEventListener('submit', this.submitHandler, true)
  }

  async submitHandler(e) {
    const form = e.target
    if (!form || form.tagName !== 'FORM') return

    const turboFrame = form.getAttribute('data-turbo-frame') || (form.dataset && form.dataset.turboFrame)
    const isWorkflowFrame = turboFrame === 'task_workflow_actions'
    // Detect common workflow action paths as a fallback
    const actionPath = form.getAttribute('action') || ''
    const isWorkflowActionPath = /\/tasks\/\d+\/(start|defer|complete|hold|resume|cancel|assign)/.test(actionPath)

    if (!isWorkflowFrame && !isWorkflowActionPath) return

    // Let Turbo handle it if it has already prevented default
    if (e.defaultPrevented) return

    e.preventDefault()
    console.debug('[workflow] intercepting submit', actionPath)

    const method = (form.getAttribute('method') || 'GET').toUpperCase()
    const headers = { Accept: 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml' }
    const body = new FormData(form)

    try {
      const res = await fetch(actionPath, { method, headers, body, credentials: 'same-origin' })
      const contentType = res.headers.get('content-type') || ''
      const text = await res.text()
      console.debug('[workflow] fetch response content-type', contentType)

      if (contentType.includes('text/vnd.turbo-stream.html') || text.includes('<turbo-stream')) {
        if (window.Turbo && typeof window.Turbo.renderStreamMessage === 'function') {
          window.Turbo.renderStreamMessage(text)
          console.debug('[workflow] rendered turbo-stream via Turbo.renderStreamMessage')
        } else {
          // Fallback: insert into DOM so Turbo can pick it up
          const wrapper = document.createElement('div')
          wrapper.innerHTML = text
          document.body.appendChild(wrapper)
          console.debug('[workflow] injected turbo-stream HTML into body')
        }
      } else if (contentType.includes('text/html')) {
        // Replace the target frame if it exists, otherwise reload page fragment
        const frame = document.getElementById('task_workflow_actions')
        if (frame) {
          frame.innerHTML = text
          console.debug('[workflow] replaced task_workflow_actions html')
        } else {
          window.location.reload()
        }
      } else {
        console.warn('[workflow] unexpected response type', contentType)
      }
    } catch (err) {
      console.error('[workflow] submit fetch failed', err)
    }
  }
}

